/* istanbul ignore file */
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { PcvizSectionLayerView } from '@mirage-projects/cw-models';

import { WidgetType } from '../ui-configuration/ui-configuration';

export type WidgetVisibilityState = 'visible' | 'hidden';
export interface WidgetVisibility {
    widget: WidgetType;
    state: WidgetVisibilityState;
}

@Injectable()
export class WidgetHelperService {
    sectionView: PcvizSectionLayerView | null = null;

    private changeSectionViewVisibilitySubject$ = new Subject<WidgetVisibility>();
    private changeSectionViewVisibility$ = this.changeSectionViewVisibilitySubject$.asObservable();
    /**
     * Changes the section view visibility
     */
    changeWidgetVisibility(widgetVisibility: WidgetVisibility): void {
        this.changeSectionViewVisibilitySubject$.next(widgetVisibility);
    }

    /**
     * Returns an observable to know when a request to show the section viewer has been done
     */
    onChangeWidgetVisibility(): Observable<WidgetVisibility> {
        return this.changeSectionViewVisibility$;
    }
}
